export default __webpack_public_path__ + "static/media/512.dd9a256d.png";